import {
  Defaults,
  Traits,
} from './shared';

import { ICON_BUTTON_BUNDLE } from './../../../const/icons';

import { COMP_BUTTON_BUNDLE } from './../../../const/components';

import { FIELD_BUNDLE_SELECTOR } from './../../../const/traits';

import { PageFormLinkedItem } from './../page-form-linked-item';

export const Bundle = (editor, options:any = {}) => {

  (FIELD_BUNDLE_SELECTOR as any).at = 9;

  return PageFormLinkedItem(editor, {
    componentName: COMP_BUTTON_BUNDLE,
    displayIcon: ICON_BUTTON_BUNDLE,
    model: {
      defaults: { ...Defaults,
        name: 'Bundle',
        traits: [ ...Traits, FIELD_BUNDLE_SELECTOR]
      }
    }
  });
}